import { Tenant } from "graphql/_Types";
import { ModalProject } from "./ModalProject";
import { ProjectFormMode } from "components/ProjectForm/ProjectForm";

interface ModalCreateProjectProps {
  tenantId?: Tenant["id"];
  onClose: () => void;
}
/**
 * Displays a Project Modal to create a new project
 */
function ModalCreateProject({ tenantId, onClose }: ModalCreateProjectProps) {
  return (
    <ModalProject
      mode={ProjectFormMode.CREATE}
      tenantId={tenantId}
      onClose={onClose}
    />
  );
}

export default ModalCreateProject;
